"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MipAmlCountry;
(function (MipAmlCountry) {
    MipAmlCountry["UK"] = "United Kingdom (Including Northern Ireland)";
    MipAmlCountry["IRELAND"] = "Republic of Ireland";
    MipAmlCountry["OTHERS"] = "Others (BAU Country)";
})(MipAmlCountry = exports.MipAmlCountry || (exports.MipAmlCountry = {}));
var MipApplicationFormSaveType;
(function (MipApplicationFormSaveType) {
    MipApplicationFormSaveType["DRAFT"] = "Draft";
    MipApplicationFormSaveType["CONFIRM"] = "Confirm";
})(MipApplicationFormSaveType = exports.MipApplicationFormSaveType || (exports.MipApplicationFormSaveType = {}));
//# sourceMappingURL=index.js.map